<template>
    <div class="bodyPage">
        <v-data-table
            :headers="tableHeaders"
            :items="sections || []"
            class="elevation-4 class"
            :loading="loading"
            :loading-text="labels.textLoading"
            v-resize="onResize"
            :search="search"
            :items-per-page=50
            :footer-props="{
                'items-per-page-text': labels.itemsPerPage,
                showFirstLastpage:true,
                'items-per-page-options':[10, 50, 100, -1]
            }"
        >
            <template v-slot:top>
                <v-toolbar flat >
                    <v-toolbar-title>{{'Setores' | translate('Setores')}}</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="labels.buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-dialog
                        v-model="dialog"
                        scrollable
                        :max-width="editDialogWidth"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="btn1" 
                                v-bind="attrs"
                                v-on="on"
                                dark
                                small
                                @click="clearEditItem()"
                            >
                                <v-icon small>
                                    mdi-plus
                                </v-icon>
                                <span>{{ 'Novo' | translate('Setores') }}</span>
                            </v-btn>
                        </template>
                        <v-form ref="form">
                            <v-card :loading="loadingModal">
                                <v-card-title>
                                    <span class="headline">{{ 'Cadastro de setor' | translate('Setores')}} </span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="registrationDialog">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="editedItem.DESCRICAO"
                                                    :label="labels.descricao"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-checkbox
                                                    v-model="editedItem.PADRAO"
                                                    true-value="S"
                                                    false-value="N"
                                                    :label="labels.inicial"
                                                ></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        class="white--text btn1" 
                                        small
                                        color="black"
                                        @click="close"
                                    >
                                        {{'Cancelar' | translate('Setores')}}
                                    </v-btn>
                                    <v-btn 
                                        class="white--text btn1" 
                                        small
                                        color="black"
                                        @click="save"
                                        :disabled="validateForm()"
                                    >
                                        {{'Salvar' | translate('Setores')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.PADRAO`]="{ item }">
                <span>{{item.PADRAO === 'S' ? labels.sim : labels.nao}}</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-row>
                    <v-col class="actionButtons">
                        <v-btn 
                            icon 
                            @click="editItem(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="actionButtons">
                        <v-btn 
                            icon 
                            @click="deleteItem(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="fit-content">
            <v-card :loading="loadingModal">
                <v-card-title>
                    {{'Você realmente deseja excluir este setor? ' | translate('Setores')}} {{editedItem.DESCRICAO}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="closeDelete"
                    >
                        {{'Cancelar' | translate('Setores')}}
                    </v-btn>
                    <v-btn  
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="deleteConfirm"
                    >
                        {{'Sim' | translate('Setores')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import translate from '../../../../src/plugins/translate'
import loadAllSections from '../../../../src/app/setor/loadAllSections'
import insertSection from '../../../../src/app/setor/insertSection'
import removeSection from '../../../../src/app/setor/removeSection'
import updateSection from '../../../../src/app/setor/updateSection'
import { createNamespacedHelpers } from 'vuex'

const user = createNamespacedHelpers('user')
export default {
    name: 'Produtos',
    components: {},
    data() {
        return {
            search: null,
            editDialogWidth: '800px',
            dialog: false,
            dialogDelete: false,
            loading: false,
            loadingModal: false,
            sections: [],
            editedItem: {},
            tableHeaders: [
                { text: translate('Descrição', 'Setores'), value: 'DESCRICAO', filterable: true, width: '70%' },
                { text: translate('Inicial', 'Setores'), value: 'PADRAO', filterable: true, width: '15%', align:'end' },
                { text: translate('Ações', 'Setores'), value: 'actions', sortable: false, width: '15%', align:'center' }
            ],
            labels: {
                textLoading: translate('Carregando setores', 'Setores'),
                buscar: translate('Buscar', 'Setores'),
                descricao: translate('Descricao', 'Setores'),
                inicial: translate('Inicial', 'Setores'),
                sim: translate('Sim', 'Setores'),
                nao: translate('Não', 'Setores')
            },
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','Setores')
            },
        }
    },
    methods: {
        async loadSections() {
            this.loading = true
            await loadAllSections()
                .then(function(response){
                    this.sections = response.data
                    this.loading = false
                }.bind(this))
                .catch(function(){ this.loading = false }.bind(this))
        },
        changeRouter(route) {
            this.$router.push(route)
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if(this.windowSize.x < 800) this.editDialogWidth = '400px'
            else if(this.windowSize.x < 1025) this.editDialogWidth = '660px'
            else this.editDialogWidth = '800px'
        },
        deleteItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        clearEditItem(){
            this.editedItem = {}
        },
        async deleteConfirm () {
            this.loadingModal = true
            removeSection(this.editedItem.ID)
                .then(() => {
                    this.loadingModal = false
                    this.loadSections()
                })
                .finally(() => this.dialogDelete = false)
        },
        validateForm() {
            if(!this.editedItem.DESCRICAO || !this.editedItem.DESCRICAO.length)  return true
            return false
        },
        close() {
            this.dialog = false
        },
        closeDelete(){
            this.editedItem = {}
            this.dialogDelete = false
        },
        editItem (item) {
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        async save() {
            this.loadingModal = true
            const promise = this.editedItem.ID ? updateSection(this.editedItem) : insertSection(this.editedItem)
            promise
                .then(() => {
                    this.loadSections()
                })
                .finally(() => {
                    this.loadingModal = false
                    this.clearEditItem()
                    this.close()
                })
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    async mounted() {
        this.onResize()
        await this.loadSections()
    },

}
</script>
<style scoped>
.headerPage{
    height: 2rem;
}
.table{
    width: 90%;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.el-tabs__item.is-active{
    color:black !important;
}
.el-tabs__active-bar{
    background-color: #000000 !important;
}
@media only screen and (max-width: 600px) {
    table{
        width: 100%;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .table{
        width: 100%;
    }
}
</style>
